import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class JobsSchedulerService {

  constructor(
    private httpService: HttpService
  ) { }

  executeJob(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/jobScheduler/execute', data, successHandle, errorHandle);
  }

}
